"use client";

// @components
import { AppProgressBar } from "next-nprogress-bar";

export const ProgressBar = AppProgressBar;

export default ProgressBar;
